/* unplugin-vue-components disabled */import { render } from "./privacy.vue?vue&type=template&id=72c377b2&scoped=true"
const script = {}

import "./privacy.vue?vue&type=style&index=0&id=72c377b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c377b2"]])

export default __exports__